<template>
  <div class="information-summary-list">
    <div class="information-summary-list-search">
      <span class="information-summary-list-search-label">Name:</span>
      <!-- <el-autocomplete class="information-summary-list-search-input" v-model="name" :fetch-suggestions="queryNameListSearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleNameSelect" /> -->
      <el-input class="information-summary-list-search-input" v-model="name" @keyup.enter.native="getList" />
      <el-button type="primary" :loading="searchLoading" @click="getList"  class="subBtn">Filter</el-button>
    </div>
    <div class="information-summary-list-export">
      <el-button type="primary" @click="exportList" :loading="exportLoading">Export</el-button>
    </div>
    <div class="table-content">
      <Table :tableHeight="500" :tableConfig="tableConfig" :number="true" :tableLoading="tableLoading" :tableTopOperate="tableTopOperate" @tableHandle="tableHandle" :eventStatus="true" >
        <template slot-scope="prop">
          <div v-if="prop.propName === 'productPictures'" class="table-pictures">
            <i v-if="prop.row.productPictures && prop.row.productPictures.length > 0" class="el-icon-picture-outline" @click="showViewer(prop.row.productPictures)"></i>
          </div>
        </template>
      </Table>
      <Pagination
        :total="pageData.total"
        :page="pageData.pageNo"
        :limit="pageData.pageSize"
        @pagination="handlePageChange"
      />
    </div>
    <el-image-viewer v-if="isShowViewer" :on-close="hideViewer" :url-list="imgList" />
  </div>
</template>
<script>
import api from '@api/cooperation';
import Table from '@/components/Table';
import Pagination from "@components/Pagination.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: 'InformationSummaryList',
  components:{
    Table,
    Pagination,
    ElImageViewer,
  },
  data () {
      return {
        name: '',
        restaurants: [{ value: "三全鲜食（北新泾店）"}],
        // 表格配置项
        tableConfig: {
          thead: [
            { prop: "name", label: ('Name'), width: 120 },
            { prop: "phoneNumber", label: ('Tel'), width: 120 },
            { prop: "email", label: ('E-mail'), width: 120 },
            { prop: "blPurchaseFromChina", label: ('Willingness to purchase products from China'), width: 120 },
            { prop: "productCategories", label: ('Desired product categories for purchase'), width: 200 },
            { prop: "problems", label: ('What problems have been encountered in your previous procurement experiences'), width: 200 },
            { prop: "productPictures", label: ('Pictures of the products you want to purchase'), width: 200, isSlot: true, notShowOverflowTooltip: true },
            { prop: "userName", label: ('Recorder'), width: 200 },
            { prop: "createTime", label: ('Recording time'), width: 150 },
          ],
          data: [],
          operate: null,
        },
        tableLoading: false,
        tableSummaryData: {},
        tableTopOperate: null,
        // 页码配置
        pageData: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
        // 页码参数
        pageNo: 1,
        pageSize: 10,
        searchLoading: false,
        imgList: [],
        isShowViewer: false,
        urlTest: '',
        exportLoading: false,
      }
  },
  async created() {
  },
  methods: {
    // 返回name模糊搜索列表
    queryNameListSearch(queryString, cb) {
      console.log(queryString)
      const restaurants = this.restaurants;
      const results = restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // name选中
    handleNameSelect(item) {
      this.name = item.value;
    },
    // 处理分页事件
    handlePageChange({page, limit}) {
      this.pageNo = page;
      this.pageSize = limit;
      this.pageData.pageNo = page;
      this.pageData.pageSize = limit;
      this.getList();
    },
    // 处理表格操作
    tableHandle(event) {
      switch (event.e) {
        default:
          console.info('未知事件');
      }
    },
    // 处理参数
    handleParams() {
      const obj = {
        name: this.name,
      }
      return obj
    },
    // 获取列表
    async getList() {
      // loading
      this.searchLoading = true;
      this.tableLoading = true;
      // 请求
      try {
        const data = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.handleParams(),
        }
        const res = await api.getInformationSummaryListApi(data);
        this.searchLoading = false;
        this.tableLoading = false;
        // 处理表格
        this.tableConfig.data = res.data.list;
        this.pageData.total = res.data.total;
      } catch (error) {
        console.log(error)
        this.searchLoading = false;
        this.tableLoading = false;
      }
    },
    async createImgUrl(fileName) {
      const res = await api.pictureShowApi(fileName);
      let blob = new Blob([res], {type: "image/png"});
      let url = window.URL.createObjectURL(blob);
      // return url
      return new Promise((resolve) => {
        resolve(url)
      })
    },
    // 导出列表
    async exportList() {
      // loading
      this.exportLoading = true;
      // 请求
      try {
        const data = this.handleParams();
        const res = await api.getInformationSummaryExportKeyApi(data);
        try {
          const file = await api.exportInformationSummaryListApi({key: res.data});
          const date = new Date();

          let fileName = 'Survey{0}.xlsx'.replace(/\{0\}/, `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
          this.exportFile(file, fileName);
          this.exportLoading = false;
        } catch (error) {
          this.$showErrorMessage(error);
          this.exportLoading = false;
        }
      } catch (error) {
        this.exportLoading = false;
      }
    },
    exportFile(value, name) {
        let url = window.URL.createObjectURL(new Blob([value]))
        let a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.setAttribute('download',name)
        document.body.appendChild(a)
        a.click() //执行下载
        window.URL.revokeObjectURL(a.href)
        document.body.removeChild(a)               
    },
    // 预览图
    showViewer(productPictures) {
      const arr = [];
      productPictures.forEach(async (ele) => {
        if (ele) {
          const res = await this.createImgUrl(ele)
          console.log(res)
          arr.push(res)
        }
      });
      this.imgList = arr;
      this.isShowViewer = true;
    },
    hideViewer() {
      this.imgList = [];
      this.isShowViewer = false;
    }
  },
}
</script>
<style scoped>
.information-summary-list {
  width: 100%;
  box-sizing: border-box;
  padding: 70px 50px 0 270px;
}
.information-summary-list-export {
  box-sizing: border-box;
  padding: 20px;
  border-bottom: 1px solid #e4e4e4;
}
.subBtn {
  border: none;
  color: #fff;
  width:130px;
  margin-left: 20px;
  background-color: #fe7b00;
}
.information-summary-list-search-label {
  font-size: 16px;
  min-width: 120px;
  color: #606266;
  text-align: right;
  margin-right: 10px;
  margin-bottom: 0px;
}
.information-summary-list-search-input {
  width: 200px;
}
.search-content {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 0 20px;
  background: #fff;
  
}
.table-content {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0px;
  background: #fff;
}
.table-content >>> .pagination-box {
  padding-top: 0;
}
.table-pictures {
  width: 100%;
  text-align: center;
}
.el-icon-picture-outline {
  font-size: 24px;
  color: #409eff;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/InformationSummaryList.vue